export default __webpack_public_path__ + "static/permit-occupation-1b1bf3fa58b1b208936c1a4916819b76.png";